import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { productLinks, products } from "../../data/products";
import { legalNav, site } from "../../data/site";
import { Brand } from "../ui/Brand";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top page-container">
        <div className="footer-about">
          <Link to="/" aria-label="Stratify home">
            <Brand light />
          </Link>
          <p>
            Book services, manage your business, and buy surplus food in
            supported locations in Nigeria.
          </p>
        </div>
        <div className="footer-column">
          <span className="footer-label">Products</span>
          {products.map((product) => (
            <a key={product.id} href={productLinks[product.id]}>
              {product.name}
              <ArrowUpRight size={14} />
            </a>
          ))}
        </div>
        <div className="footer-column">
          <span className="footer-label">Company</span>
          <a href="https://stratifyhub.app/services?page=1">Service categories</a>
          <Link to="/#about">About Stratify</Link>
          <Link to="/contact">Contact us</Link>
        </div>
        <div className="footer-column">
          <span className="footer-label">Follow</span>
          {site.socials.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noreferrer"
            >
              {social.label}
              <ArrowUpRight size={14} />
            </a>
          ))}
        </div>
      </div>
      <div className="footer-wordmark" aria-hidden="true">
        stratify<span>.</span>
      </div>
      <div className="footer-bottom page-container">
        <span>© {new Date().getFullYear()} Stratify Services</span>
        <div>
          {legalNav.map((item) => (
            <Link key={item.href} to={item.href}>
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
